export default __webpack_public_path__ + "static/media/compactdiscs.156d907c.jpg";